import { Topic } from "@mui/icons-material";
import { Button, Card, CardContent, CircularProgress, Grid, LinearProgress, Stack, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Col, Row } from "reactstrap";
import { BreadcrumbBar } from "../Breadcrumb";
import { ExpandableContainer } from "../Shared/ExpandableContainer";
import { DatePicker } from "../Shared/FormControls/DatePicker";
import FormNavigation from "../Shared/FormNavigation";
import { FormSectionHeader } from "../Shared/FormSectionHeader";
import FileUpload from "./FileUpload";
import "./index.scss";
import { MaterialAuditGroupForm } from "./MaterialAuditGroup";
import { useMaterialAudit } from "./useMaterialAudit";


export const MaterialAudit: React.FC = ({
    ...props
}) => {



    const { models, operations } = useMaterialAudit();

    const { loading, bread, detailsValid, audit, materialStates } = models;
    const {
        isReadonly,
        getStatusLabel,
        onReload,
        onDelete,
        onClose,
        onUpdateAuditDetail,
        onUpdateDateAudit,
        onUpdateDateNextAudit,
        onUpdateResponsibleFleetEngineer,
        onExportResults,
        onImportResults

    } = operations;

    return (
        <ExpandableContainer>
            <BreadcrumbBar
                current={bread}
                previous={[{
                    name: "Audit",
                    href: "/audit"
                }]}
            />
            <Typography variant="h4" sx={{ py: 3 }}>{audit ? <>
                <Topic fontSize="inherit" sx={{ opacity: .8 }} color="primary" />
                {audit.reference}
                <FormNavigation />
            </> : <CircularProgress />} </Typography>

            <Row>
                <Col>
                    {getStatusLabel()}

                </Col>
                <Col xs="auto">
                    <Stack direction="row" gap={1}>

                        <Button size="small" variant="outlined" color="primary" disabled={loading} onClick={() => onExportResults()}>Export</Button>
                        <FileUpload
                            disabled={loading || isReadonly()}
                            auditId={audit?.materialAuditId ?? ""}
                            onImported={onImportResults}
                        />
                        <Button size="small" variant="outlined" color="error" disabled={loading || isReadonly()} onClick={() => onDelete()}>Delete</Button>

                    </Stack>

                </Col>
            </Row>


            {audit?.materialAuditResults && <>
                <MaterialAuditGroupForm
                    materialAudit={audit}
                    materialStates={materialStates}
                    updateMaterialAudit={onUpdateAuditDetail}
                    reloadMaterial={onReload}
                    readonly={isReadonly()}
                    loading={loading}
                />

                <div className="form-section">
                    <Card>

                        <FormSectionHeader label="Complete Audit" />

                        <CardContent>

                            <Typography variant="subtitle1">
                                Once all materials in this audit have been checked and the <strong>audit date</strong>, <strong>next audit date</strong> and <strong>responsible fleet engineer</strong> has been specified, you can close the audit. The materials will <strong>not</strong> be updated with any differences identified; this should be done manually.
                            </Typography>
                            <form id="audit-details-form">
                                <Grid container>
                                    <Grid item xs={3} sm={2} sx={{ mb: 2 }}>
                                        <DatePicker
                                            label="Audit Date"
                                            value={audit?.dateAudit}
                                            onChange={(value) => onUpdateDateAudit(value)}
                                            required
                                            disabled={isReadonly()}
                                        />
                                    </Grid>
                                    <Grid item xs={3} sm={2} sx={{ mb: 2, ml: 2 }}>
                                        <DatePicker
                                            label="Next Audit Date"
                                            value={audit?.dateNextAudit}
                                            onChange={(value) => onUpdateDateNextAudit(value)}
                                            required
                                            disabled={isReadonly()}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} sx={{ mb: 2, ml: 2 }}>
                                        <TextField
                                            label="Responsible Fleet Engineer at Audit"
                                            value={audit?.responsibleFleetEngineer || ""}
                                            onChange={(e) => onUpdateResponsibleFleetEngineer(e.target.value)}
                                            required
                                            disabled={isReadonly()}
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </form>

                            {!isReadonly() &&
                                <Button
                                    variant="contained"
                                    onClick={onClose}
                                    disabled={!detailsValid}
                                >
                                    Complete
                                </Button>
                            }

                            {loading &&
                                <CircularProgress size="1em" sx={{ position: 'absolute', m: 1.25 }} />
                            }

                        </CardContent>
                    </Card>

                </div>
            </>}
        </ExpandableContainer>
    );
}